import ajax  from '@/axios';

const baseURL = `${process.env.VUE_APP_BASE_API_URL}${process.env.VUE_APP_BASE_API}`

/**
 * 主题类型
 */

export const getTypeTheme = params => {
  return ajax({
    url: `${baseURL}/dict/type/theme`,
    method: 'get',
    params
  })
}

/**
 * 类型
 */

export const getTypeSustainability = params => {
  return ajax({
    url: `${baseURL}/dict/type/sustainability`,
    method: 'get',
    params
  })
}


/**
 * 获取标签集合
 */
export const getTagsList = params => {
  return ajax({
    url: `${baseURL}/api/tags/list`,
    method: 'get',
    params
  })
}

/**
 * Newsroom列表
 */
export const getFronttopPage = params => {
  return ajax({
    url: `${baseURL}/api/fronttop/page`,
    method: 'get',
    params
  })
}

/**
 * 产品应用
 */
export const getProductApplication = params => {
  return ajax({
    url: `${baseURL}/dict/type/productApplication`,
    method: 'get',
    params
  })
}

/**
 * 轴
 */
export const getProductAxle = params => {
  return ajax({
    url: `${baseURL}/dict/type/productAxle`,
    method: 'get',
    params
  })
}

/**
 * 轮胎size
 */
export const getTypeSize = params => {
  return ajax({
    url: `${baseURL}/api/product/size`,
    method: 'get',
	params
  })
}

/**
 * 轮胎花纹pattern
 */
export const getProductPattern = params => {
  return ajax({
    url: `${baseURL}/api/product/pattern`,
    method: 'get',
	params
  })
}

/**
 * 欧盟标签
 */
export const getProductEuLabels = params => {
  return ajax({
    url: `${baseURL}/dict/type/euLabels`,
    method: 'get',
	params
  })
}

/**
 * product列表
 */
export const getProductPage = params => {
  return ajax({
    url: `${baseURL}/api/product/page`,
    method: 'get',
	params
  })
}

/**
 * product详情
 */
export const getProductDetails = params => {
  return ajax({
    url: `${baseURL}/api/product/${params}`,
    method: 'get'
  })
}

/**
 * 联系我们
 */
export const contactus = data => {
  return ajax({
    url: `${baseURL}/api/contactus/add`,
    method: 'post',
	headers: { 'Content-Type': 'application/json' },
    data
  })
}